import React from 'react';

// Context
import { useTheme } from 'context/ThemeContext';

// CSS
import './Switch.css';

/**
 * Switch
 *
 * Reusable on/off switch with theme-aware colors.
 */
const Switch = ({ checked = false, disabled = false, onChange }) => {
    const { theme } = useTheme();

    const handleToggle = () => {
        if (disabled) return;
        if (onChange) onChange(!checked);
    };

    return (
        <button
            type="button"
            className="switch-container"
            role="switch"
            aria-checked={checked}
            aria-disabled={disabled}
            disabled={disabled}
            onClick={handleToggle}
            style={{
                backgroundColor: checked ? theme.highlight : theme.backgroundMuted,
                borderColor: checked ? theme.highlight : theme.foregroundMuted,
            }}
        >
            <span
                className="switch-thumb"
                style={{
                    transform: checked ? 'translateX(20px)' : 'translateX(0px)',
                    backgroundColor: checked ? theme.highlightForeground : theme.foreground,
                }}
            />
        </button>
    );
};

export default Switch;
